import type { ReactNode } from 'react';
import { RubricsWorkspace } from '../components/evaluation/RubricsWorkspace';

/**
 * ADMIN-02 (F19.02) — scorecard rubrics, admin redesign batch 2 Option A: the list beside the open rubric. Each edit saves a
 * new version; a round keeps the version it was set up with (master plan S12). With none chosen, the first opens.
 */
export function RubricsPage(): ReactNode {
  return <RubricsWorkspace selectedId={null} />;
}
